import Vue from 'vue'
import App from './App.vue'
import VxeUIAll, { VxeUI } from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
import VxeUIPluginValidator from '@vxe-ui/plugin-validator'
import VueMarkdown from 'vue-markdown-v2';

Vue.component('VueMarkdown', VueMarkdown);

VxeUI.use(VxeUIPluginValidator)

Vue.use(VxeUIAll)
Vue.use(VxeUITable)


Vue.directive('scoped', function(element, binding) {
  const scopedId = binding.value.$options._scopeId
  if (!scopedId) {
    return
  }
  
  const componentTag = element.__vue__.$vnode.tag
  let target = [ ]

  if (componentTag.indexOf('ElPopover') !== -1) {
    // popover组件
    target.push(element.children[0])
  } else {
    target.push(element)
  }
  target.forEach(item => { item.setAttribute(scopedId, '') })

})


// 插件
import './plugins'
// import './mock'

Vue.config.productionTip = false

import router from './router/routers'
import './router'
import store from './store'
import i18n from '@/plugins/i18n'

new Vue({
  render: h => h(App),
  router,
  store,
  i18n
}).$mount('#app')
